import React from 'react';
import AdBanner from '../components/AdBanner';
import SEO from '../components/SEO';

const TermsConditions = () => {
  return (
    <div className="min-h-screen bg-stone-50 py-10 md:py-16">
      <SEO
        title="Terms & Conditions | Nath Nagri Bareilly"
        description="Terms and Conditions for using the Nath Nagri Bareilly website."
        keywords="terms and conditions, terms of use, nathnagri legal"
      />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-10 text-center md:text-left">
          <h1 className="text-4xl font-extrabold text-stone-900 mb-4">Terms and Conditions (सेवा की शर्तें)</h1>
          <p className="text-lg text-stone-600">Last updated: {new Date().toLocaleDateString()}</p>
        </div>

        <div className="flex flex-col lg:flex-row gap-8">
          {/* Main Content (Left) */}
          <div className="flex-1 bg-white p-8 rounded-2xl border border-stone-100 shadow-sm prose prose-lg prose-stone max-w-none [&>p]:mb-6 [&>h3]:text-2xl [&>h3]:font-bold [&>h3]:mb-4 [&>h3]:mt-8">
            <p>
              Welcome to <strong>Nath Nagri Bareilly</strong>.
            </p>
            <p>
              These terms and conditions outline the rules and regulations for the use of Nath Nagri Bareilly's Website, located at nathnagribareilly.com.
            </p>
            <p>
              By accessing this website we assume you accept these terms and conditions. Do not continue to use Nath Nagri Bareilly if you do not agree to take all of the terms and conditions stated on this page.
            </p>

            <h3>1. Website Usage Terms</h3>
            <p>
              The content provided on this website is intended for general informational and educational purposes only, particularly focusing on the religious, cultural, and spiritual heritage of the Nath Temples in Bareilly. 
            </p>
            <ul>
              <li>You must be at least 13 years of age to use this website.</li>
              <li>You agree to use this site only for lawful purposes and in a manner that does not infringe the rights of, or restrict or inhibit the use and enjoyment of this site by any third party.</li>
              <li>Harassment through the comment sections or user forums will not be tolerated and will result in a ban.</li>
            </ul>

            <h3>2. Intellectual Property & Content Ownership</h3>
            <p>
              Unless otherwise stated, Nath Nagri Bareilly and/or its licensors own the intellectual property rights for all material on the site. All intellectual property rights are reserved. You may access this from Nath Nagri Bareilly for your own personal use subjected to restrictions set in these terms and conditions.
            </p>
            <p>You must not:</p>
            <ul>
              <li>Republish material from Nath Nagri Bareilly without direct attribution.</li>
              <li>Sell, rent or sub-license material from Nath Nagri Bareilly.</li>
              <li>Reproduce, duplicate or copy material from Nath Nagri Bareilly for commercial purposes.</li>
            </ul>

            <h3>3. User Generated Content (Blogs & Comments)</h3>
            <p>
              Parts of this website offer an opportunity for users to post and exchange opinions, religious experiences, and information (such as community Blogs and Comments). Nath Nagri Bareilly does not filter, edit, publish or review Comments prior to their presence on the website. Comments do not reflect the views and opinions of Nath Nagri Bareilly, its agents, or affiliates.
            </p>
            <p>
              However, we reserve the right to monitor all Comments and to remove any Comments which can be considered inappropriate, offensive or causes breach of these Terms and Conditions.
            </p>

            <h3>4. External Links</h3>
            <p>
              Our website may contain links to external sites that are not operated by us (including advertisement links fed by Google AdSense). We have no control over the content and practices of these sites, and cannot accept responsibility or liability for their respective privacy policies.
            </p>

            <h3>5. Limitation of Liability</h3>
            <p>
              In no event shall Nath Nagri Bareilly, nor any of its developers, be held liable for anything arising out of or in any way connected with your use of this website whether such liability is under contract. Nath Nagri Bareilly, including its staff, shall not be held liable for any indirect, consequential or special liability arising out of or in any way related to your use of this website.
            </p>

            <h3>6. Modifications</h3>
            <p>
              Nath Nagri Bareilly is permitted to revise these Terms at any time as it sees fit, and by using this Website you are expected to review these Terms on a regular basis.
            </p>

          </div>

          {/* Sidebar (Right) */}
          <div className="w-full lg:w-80 flex-shrink-0">
            <AdBanner placement="sidebar" pageName="terms" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsConditions;
